exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ni-dragable-table tr.drop-over-downward td {\n  border-bottom: 2px dashed #4182eb !important;\n}\n.ni-dragable-table tr.drop-over-upward td {\n  border-top: 2px dashed #4182eb !important;\n}\n", ""]);

// exports
